module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAJFBMVEVHcEw6euY5eOM6eeM6eOQ5eOU6eOM4eOU6eOQ6eOQ6eOQ6eOM5k65QAAAAC3RSTlMAJuRyZUbyEtCti37VKEQAAAEHSURBVDjLzdTLlsMgCABQBRWQ///fRuMDTHo6y3HVcG4MIjSErysKJx9BSacBVUUbEdWCT6OanDleG8YEpeip8gitvWQ+LxUpZB+U9dJUEdiqa6+qduHIx6oSyJmSZ85GlRCuUMX5GPe5tkrtHHWeBYzZqh8vNlMe5lZlloDgygUVyJtbrZJnyKHyw3Rl16txV9fa4rfxd/qfTcQ/GPAtzu/mS0cfZivieKj0HITc2siq5La+FapX6fh8V1Wd6qaIaWkaaKtWQ7hafatixu5Wvc45BzxKz2sIIsy7uAxXmzjsUaE95UDE5gqLy3AqIrHFBGYRqbXGcPwbvbWCX20WMfxaEfP49QFzbhstfiNIAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/device/info-inform.png
// module id = 8MuL
// module chunks = 1